import {Column} from 'react-table'
import {Model} from '@/_metronic/helpers'
import {
  TextCell,
  DateCell,
  ActionsCell,
  IdentityCell,
  CustomHeader
} from '@/components/table/columns'

import {
  TrxStatusCell,
  TrxPaymodeCell,
  TrxAmountCell,
  TrxCreditCell
} from './TrxCells'

const df = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric'
} as Intl.DateTimeFormatOptions

const Columns: ReadonlyArray<Column<Model>> = [{
  Header: (props) => <CustomHeader tableProps={props} title='Name' className='min-w-125px' />,
  id: 'username',
  Cell: ({...props}) =>
    <IdentityCell
      email={props.data[props.row.index].user.email}
      displayName={props.data[props.row.index].user.username}
      to={`/p2c/customers/${props.data[props.row.index].user._id}/overview`}
    />
}, {
  Header: (props) => <CustomHeader tableProps={props} title="Date" className='min-w-125px' />,
  id: 'createdAt',
  Cell: ({...props}) => <DateCell date={props.data[props.row.index].date} format={df}/>
}, {
  Header: (props) => <CustomHeader tableProps={props} title="Paymode" className='min-w-125px' />,
  id: 'transaction.type',
  Cell: ({...props}) => (
    <TrxPaymodeCell
      paymode={props.data[props.row.index].type}
      country={props.data[props.row.index].country}
    />
  )
}, {
  Header: (props) => <CustomHeader tableProps={props} title="Amount" className='min-w-125px' />,
  id: 'transaction.amount',
  Cell: ({...props}) => (
    <TrxAmountCell
      amount={props.data[props.row.index].amount}
      currency={props.data[props.row.index].currency}
    />
  )
}, {
  Header: (props) => <CustomHeader tableProps={props} title="Payout" className='min-w-125px' />,
  id: 'transaction.payout',
  Cell: ({...props}) => (
    <TrxAmountCell
      amount={props.data[props.row.index].payout}
      currency={props.data[props.row.index].payoutCurrency}
    />
  )
}, {
  Header: (props) => <CustomHeader tableProps={props} title="Code" className='min-w-125px' />,
  id: 'transaction.code',
  Cell: ({...props}) => (
    <TextCell content={props.data[props.row.index].code} />
  )
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Status' className='min-w-70px sortable' />,
  id: 'status',
  Cell: ({...props}) => (
    <TrxStatusCell
      status={props.data[props.row.index].statuses.at(-1).status || ''}
    />
  )
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Credits' className='min-w-70px' />,
  id: 'credits',
  Cell: ({...props}) => (
    <TrxCreditCell
      credit={props.data[props.row.index].credit}
      status={props.data[props.row.index].statuses.at(-1)?.status || ''}
    />
  )
}, {
  Header: (props) => (
    <CustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
  ),
  id: 'actions',
  Cell: ({...props}) => (
    <ActionsCell
      itemForUpdate={props.data[props.row.index]}
      actions={[{
        icon: 'exit-right-corner',
        label: 'View Transaction',
        openModal: 'details'
      }]}
    />
  )
}]

export {Columns}
